import React, { Fragment, useState } from 'react';
import T from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  FLEX_DRAFT_SCHEDULE_FORM_COPY_DICTIONARY,
  FLEX_DRAFT_SCHEDULE_FORM_SEMI_MONTHLY_DICTIONARY,
  FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY,
} from '@dmi/shared/redux/Payments/FlexDraft/constants';

import { KeyboardAvoidingScrollView, P2 } from '../../../base_ui';
import ScheduleSemiMonthlyRow from './ScheduleSemiMonthlyRow';
import { SecondaryHeader } from '../../../ScreenHeaders';
import { InfoSection } from '../../sharedComponents';
import {
  SelectButtonWrapper,
  SemiMonthlyCardContent,
  SemiMonthlyFormContainer,
  SemiMonthlyFormItemHeading,
  StyledH2,
  StyledLargePrimaryButton,
} from './styledComponents';

const ScheduleSemiMonthly = ({
  dispatchChangeInput,
  dispatchSetSelectedDraftScheduleStep,
  formValues: { firstDraft, secondDraft },
  navigation,
}) => {
  const [localFirstDraft, setLocalFirstDraft] = useState(firstDraft);
  const [localSecondDraft, setLocalSecondDraft] = useState(secondDraft);

  const {
    heading,
    infoSectionData,
    text,
    title,
  } = FLEX_DRAFT_SCHEDULE_FORM_COPY_DICTIONARY[FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY];
  const {
    firstDraft: firstDraftDictionary,
    secondDraft: secondDraftDictionary,
  } = FLEX_DRAFT_SCHEDULE_FORM_SEMI_MONTHLY_DICTIONARY;

  const handleOnPressSelectPaymentDates = () => {
    // Update redux form state with the selected payment dates in local state
    dispatchChangeInput({
      field: 'firstDraft',
      form: FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY,
      value: localFirstDraft,
    });
    dispatchChangeInput({
      field: 'secondDraft',
      form: FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY,
      value: localSecondDraft,
    });
    dispatchSetSelectedDraftScheduleStep({ step: '' });
    navigation.navigateDeprecated('FlexDraftSetupOverview');
  };

  return (
    <Fragment>
      <SecondaryHeader
        handleBack={() => navigation.navigateDeprecated('FlexDraftScheduleSelect')}
        title={title}
      />
      <KeyboardAvoidingScrollView scrollViewProps={{ showsVerticalScrollIndicator: false }}>
        <SemiMonthlyCardContent>
          <StyledH2>{heading}</StyledH2>
          <P2>
            <FormattedMessage id={text} />
          </P2>
          <SemiMonthlyFormContainer>
            <SemiMonthlyFormItemHeading>{firstDraftDictionary.heading}</SemiMonthlyFormItemHeading>
            {firstDraftDictionary.menuItems.map(({ label, value }) => (
              <ScheduleSemiMonthlyRow
                key={value}
                label={label}
                onPress={() => setLocalFirstDraft(value)}
                selectedValue={localFirstDraft}
                value={value}
              />
            ))}
            <SemiMonthlyFormItemHeading>{secondDraftDictionary.heading}</SemiMonthlyFormItemHeading>
            {secondDraftDictionary.menuItems.map(({ label, value }) => (
              <ScheduleSemiMonthlyRow
                key={value}
                label={label}
                onPress={() => setLocalSecondDraft(value)}
                selectedValue={localSecondDraft}
                value={value}
              />
            ))}
            <InfoSection data={infoSectionData} />
          </SemiMonthlyFormContainer>
        </SemiMonthlyCardContent>
      </KeyboardAvoidingScrollView>
      <SelectButtonWrapper>
        <StyledLargePrimaryButton
          disabled={!localFirstDraft || !localSecondDraft}
          label="Select Payment Dates"
          onPress={handleOnPressSelectPaymentDates}
        />
      </SelectButtonWrapper>
    </Fragment>
  );
};

ScheduleSemiMonthly.propTypes = {
  dispatchChangeInput: T.func.isRequired,
  dispatchSetSelectedDraftScheduleStep: T.func.isRequired,
  formValues:
    T.shape({
      firstDraft: T.string.isRequired,
      secondDraft: T.string.isRequired,
    }).isRequired,
  navigation: T.object.isRequired,
};

export default ScheduleSemiMonthly;
